import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
//import ReCAPTCHA from "react-google-recaptcha";
import Reaptcha from "reaptcha";
import './dialog-app.styles.scss';

import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import countryNames from 'react-phone-number-input/locale/en'

import { getCountries, getCountryCallingCode } from 'react-phone-number-input/input'

export const DialogApp = (props) => {
  const [open, setOpen] = useState(props.autoOpen || false);
  const [nameValue, setNameValue] = useState("");
  const [emailValue, setEmailValue] = useState("");
  const [phoneNumberValue, setPhoneNumberValue] = useState("");

  const [bodyValue, setBodyValue] = useState("");
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [message, setMessage] = useState('');
  const [errorEmail, setErrorEmail] = useState(null);

  let key = 0;

  const [captchaValido, setCaptchaValido] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const captchaRef = useRef(null);

  useEffect(() => {
    verifySendButtonDisabled();
  }, [captchaValido, nameValue, emailValue, phoneNumberValue]);

  /*const doSomething = () => {
    //do something like submit a form and then refresh recaptcha
    setRefreshReCaptcha(r => !r);
  } */

  const sendEmailHandler = (e) => {
    e.preventDefault();

    //console.log(setCaptchaToken.getResponses);
   // console.log("El usuario no es un robot");
    //cambiarUsuarioValido(true);
    //cambiarCaptchaValido(true);

    //6LecPukiAAAAALYuaqKKxZTIIEuTkjgdDLxQE0u5

   
    //console.log("Body is : " + bodyValue);
    //console.log("Email to send is : " + props.email);

    // Example to connect to a http request using axios library
    // you have to install using "npm install axios --save"

    let axiosConfig = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        origin: "x-requested-with",
      },

      crossDomain: true,
    };


   
    var postData = {
      to:  props.email,
      //district: props.district,
      //logde: props.lodge,
      text: "You are receiving this message from the Sons of Norway lodge directory with someone interested in communicating with the lodge. Please reach out to them.",
      phoneNumber:phoneNumberValue,
      email:emailValue,
      name:nameValue,
      html: "Here's an <strong>HTML version</strong> of the email.",
    };
    //http://192.168.73.12:9000/

    //console.log("Body is : " + postData.text);
     axios.post('https://apps.sofn.com/api/email', postData , axiosConfig )

     //axios.post('http://localhost:4000/api/email', postData , axiosConfig )
      .then(function (response) {
        //console.log("It was sent correctly");
        return response;
      })
      .catch(function (error) {
        //console.log("Failed to send");

        return error;
      });

    // Clean all fields
   
    setBodyValue("");
    setBtnDisabled(true);
    setOpen(false);
    setCaptchaValido(false);


    //console.log("Por favor acepta el captcha");
  
  };

  const cancelHandler = () => {
  
    setBodyValue("");
    setBtnDisabled(true);
    setOpen(false);
    setCaptchaValido(false);
    setPhoneNumberValue("");
 
  };

  const onChangeNameValue = (newValue) => {
    setNameValue(newValue.target.value);
  };

  const onChangeEmailValue = (newValue) => {
    setEmailValue(newValue.target.value);
    if (!isValidEmail(newValue.target.value)) {
      setErrorEmail('Email is invalid');
    } else {
      setErrorEmail(null);
    }

    setMessage(newValue.target.value);

  };

  const onChangePhoneNumberValue = (newValue) => {
    const formattedPhoneNumber = formatPhoneNumber(newValue.target.value);
    //console.log(formattedPhoneNumber);
    setPhoneNumberValue(formattedPhoneNumber);
    //verifySendButtonDisabled();
  };



  const onChangeBodyValue = (newValue) => {
    setBodyValue(newValue.target.value);
    //verifySendButtonDisabled();
  };

  const onOpen = () => {
    setOpen(true);
    //captchaRef.current.reset();
  };

  const verify = () => {
    //console.log("Entró al verify")
    captchaRef.current.getResponse().then((res) => {
      //console.log("Entró al response del verify");
      //console.log("Resultado del verify: " + res);
      setCaptchaToken(res);
      setCaptchaValido(true);
    });
  };

  const expire = () => {
    setCaptchaValido(false);
  };

  const verifySendButtonDisabled = () => {
   
    if (nameValue === "" || errorEmail !== null || captchaValido === false) {
      setBtnDisabled(true);
    } else {
      setBtnDisabled(false);
    }
  };

  function formatPhoneNumber(value) {
    // if input value is falsy eg if the user deletes the input, then just return
    if (!value) return value;
  
    // clean the input for any non-digit values.
    const phoneNumber = value.replace(/[^\d]/g, '');
  
    // phoneNumberLength is used to know when to apply our formatting for the phone number
    const phoneNumberLength = phoneNumber.length;
  
    // we need to return the value with no formatting if its less then four digits
    // this is to avoid weird behavior that occurs if you  format the area code to early
  
    if (phoneNumberLength < 4) return phoneNumber;
  
    // if phoneNumberLength is greater than 4 and less the 7 we start to return
    // the formatted number
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
  
    // finally, if the phoneNumberLength is greater then seven, we add the last
    // bit of formatting and return it.
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  }

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  return (
    <>
      <Button  className="sonsBt"
       
        variant="contained"
        onClick={onOpen}
      >
        Contact Lodge Officers
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
      >
        <DialogTitle id="dialog-title">
          Contact Lodge Officers<br />
          <small>{props.lodgeName} {props.districtId}-{props.lodgeId}</small>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="dialog-description">
            Send an email to the lodge Officers with your information and they will contact you.
          </DialogContentText>
          <Box component="form" autoComplete="off">
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Name"
              fullWidth
              variant="standard"
              required
              onChange={onChangeNameValue}
              inputProps={{ maxLength: 200 }}
            />{" "}
            <TextField
              autoFocus
              margin="dense"
              id="email"
              label="Email"
              fullWidth
              variant="standard"
              required
              onChange={onChangeEmailValue}
            />
            {errorEmail && <span style={{color: 'red'}}>{errorEmail}</span>}
            <TextField
              autoFocus
              margin="dense"
              id="phone"
              label="Phone Number"
              fullWidth
              variant="standard"
              onChange={onChangePhoneNumberValue}
              value={phoneNumberValue}
              maxLength="11"
            />
          </Box>
          <div className="recaptcha">
            <Reaptcha
              sitekey={"6LecPukiAAAAALYuaqKKxZTIIEuTkjgdDLxQE0u5"}
              ref={captchaRef}
              onVerify={verify}
              onExpire={expire}
            ></Reaptcha>
          </div>
        </DialogContent>

        <DialogActions>
          <Button
            sx={{
              color: "white",
              backgroundColor: "#4bb1ca",
              borderColor: "green",
            }}
            variant="contained"
            onClick={cancelHandler}
          >
            Cancel
          </Button>
          <Button
            sx={{
              color: "white",
              backgroundColor: "#4bb1ca",
              borderColor: "green",
            }}
            variant="contained"
            autoFocus
            onClick={sendEmailHandler}
            disabled={btnDisabled}
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};



export default DialogApp;
